import React, { useEffect, useState } from "react";
import { withRouter, Link, useLocation } from "react-router-dom";
import "./SmsSettings.css";
import CustomSelect from "../../../../../../../../Util/CustomSelect/CustomSelect";
import useSearchParam from "../../../../../../../../hooks/UrlSearchParam";
import axiosApi from "../../../../../../../../core/interceptor/interceptor";
import { config } from "../../../../../../../../config";
import { PLAYER_TYPE, SCHEDULE_TYPE, TAGS, OLD_TAGS } from "../../../../../../../../Util/helper";
import Timepicker from '../../../../../../../../Util/Timepicker/Timepicker';
import minusSvg from '../../../../../../../../assets/minus-pri.png';
import plusSvg from '../../../../../../../../assets/plus-icon.svg';
import back from '../../../../../../../../assets/arrow-back.svg';
import { messages } from '../../../../../../../../messages';
import { useHistory } from "react-router-dom";

function SmsSettings(props) {
  const leagueId = useSearchParam(props.location).get('leagueId');
  const [payload, setPayload] = useState({});
  const history = useHistory();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const search = useLocation().search;
  const season_id = new URLSearchParams(search).get('season_id');
  const [daysData, setDaysData] = useState([]);
  const [hoursData, setHoursData] = useState([]);
  const [errors, setErrors] = useState();
  const [disabled, setDisabled] = useState(false);
  const [defaultTemplate, setDefaultTemplates] = useState([]);
  useEffect(() => {
    setDaysData(() => {
      const data = [];
      for (let i = 0; i <= 30; i++) {
        data.push({ title: i > 0 ? `${i} day before match` : `Match day`, value: i })
      }
      return data;
    })
    setHoursData(() => {
      const data = [];
      for (let i = 0; i < 15; i++) {
        data.push({ title: `${i + 1} hours before match`, value: i + 1 })
      }
      return data;
    })
    getLeague(leagueId);
    getDefaultTemplates();
    //eslint-disable-next-line
  }, []);



  const getLeague = (league_id) => {
    axiosApi.get(`${config.apiUrl}/leagues/${league_id}`).then((resp) => {
      let leagueData = { ...resp.data.data };
      const regularReminderData = leagueData.regular_reminder_settings
        ? JSON.parse(leagueData.regular_reminder_settings)
        : [{ day: null, schedule_type: null, hour: null }];
      leagueData = { ...leagueData, regular_reminder_settings: regularReminderData };

      leagueData.playoff_reminder_settings = leagueData.playoff_reminder_settings
        ? JSON.parse(leagueData.playoff_reminder_settings)
        : [{ day: null, schedule_type: null, hour: null }];
      const loc_fields = leagueData.league_locations.reduce((prev, curr) => {
        prev.push({
          location: curr.location,
          fields: curr.fields.map(field => field.locations_and_field)
        });
        return prev;
      }, []);
      leagueData.location = loc_fields;
      if (leagueData.status === 'complete') {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
      setPayload({ ...leagueData });

    }).catch((err) => {
      console.error(err);
    });
  }

  const getDefaultTemplates = () => {
    axiosApi.get(`${config.apiUrl}/misc/templates`).then((resp) => {
      const temp = {};
      if (resp.data?.data?.length) {

        resp.data?.data.forEach((template) => {
          temp[template.type] = template;
        })
      }
      setDefaultTemplates(temp);
    }).catch((err) => {
    })
  }
  useEffect(() => {
    handleValidation();
    // eslint-disable-next-line
  }, [payload])

  const handleValidation = () => {
    let errorArr = {
      regular_reminder_user_type: '',
      regular_reminder_template: '',
      regular_reschedule_message_template: '',
      regular_cancel_message_template: '',
      regular_reminder_settings: [],
      playoff_reminder_user_type: '',
      playoff_reminder_template: '',
      playoff_reminder_settings: [],
      playoff_reschedule_message_template: '',
      playoff_cancel_message_template: '',
    };
    let formIsValid = true;


    if (payload.enable_sms_reminder) {

      // Handle Regular reminder validation
      if (payload.enable_regular_reminder) {
        if (!payload['regular_reminder_user_type']?.trim()) {
          formIsValid = false;
          errorArr["regular_reminder_user_type"] = messages && messages.selectSendTo;
        }
        if (!payload['regular_reminder_template']?.trim()) {
          formIsValid = false;
          errorArr["regular_reminder_template"] = messages && messages.messageTemplateIsRequired;
        }

        if (!payload['regular_reschedule_message_template']?.trim()) {
          formIsValid = false;
          errorArr["regular_reschedule_message_template"] = messages && messages.rescheduleMessageTemplateIsRequired;
        }

        if (!payload['regular_cancel_message_template']?.trim()) {
          formIsValid = false;
          errorArr["regular_cancel_message_template"] = messages && messages.cancelMessageTemplateIsRequired;
        }

        payload['regular_reminder_settings']?.forEach((settings, key) => {
          if (!errorArr['regular_reminder_settings'][key]) {
            errorArr['regular_reminder_settings'][key] = {};
          }
          if (settings["day"] < 0) {
            formIsValid = false;
            errorArr['regular_reminder_settings'][key]['day'] = messages && messages.dayIsRequired;
          }
          if (settings["day"] === 0 && !settings["schedule_type"]) {
            formIsValid = false;
            errorArr['regular_reminder_settings'][key]['schedule_type'] = messages && messages.scheduleTypeIsRequired;
          }
          if ((settings.day === 0 && settings.schedule_type === 'fixed' || settings.day !== 0) && !settings["time"]) {
            formIsValid = false;
            errorArr['regular_reminder_settings'][key]['time'] = messages && messages.timeIsRequired;
          }

          if (settings.day === 0 && settings.schedule_type === 'variable' && !settings["hour"]) {
            formIsValid = false;
            errorArr['regular_reminder_settings'][key]['hour'] = messages && messages.hoursBeforeIsRequired;
          }

        });
      }

      // Handle playoff reminder validation
      if (payload.enable_playoff_reminder) {
        if (!payload['playoff_reminder_user_type']?.trim()) {
          formIsValid = false;
          errorArr["playoff_reminder_user_type"] = messages && messages.selectSendTo;
        }
        if (!payload['playoff_reminder_template']?.trim()) {
          formIsValid = false;
          errorArr["playoff_reminder_template"] = messages && messages.messageTemplateIsRequired;
        }

        if (!payload['playoff_reschedule_message_template']?.trim()) {
          formIsValid = false;
          errorArr["playoff_reschedule_message_template"] = messages && messages.rescheduleMessageTemplateIsRequired;
        }

        if (!payload['playoff_cancel_message_template']?.trim()) {
          formIsValid = false;
          errorArr["playoff_cancel_message_template"] = messages && messages.cancelMessageTemplateIsRequired;
        }


        payload['playoff_reminder_settings']?.forEach((settings, key) => {
          if (!errorArr['playoff_reminder_settings'][key]) {
            errorArr['playoff_reminder_settings'][key] = {};
          }
          if (settings["day"] < 0) {
            formIsValid = false;
            errorArr['playoff_reminder_settings'][key]['day'] = messages && messages.dayIsRequired;
          }
          if (settings["day"] === 0 && !settings["schedule_type"]) {
            formIsValid = false;
            errorArr['playoff_reminder_settings'][key]['schedule_type'] = messages && messages.scheduleTypeIsRequired;
          }
          if ((settings.day === 0 && settings.schedule_type === 'fixed' || settings.day !== 0) && !settings["time"]) {
            formIsValid = false;
            errorArr['playoff_reminder_settings'][key]['time'] = messages && messages.timeIsRequired;
          }

          if (settings.day === 0 && settings.schedule_type === 'variable' && !settings["hour"]) {
            formIsValid = false;
            errorArr['playoff_reminder_settings'][key]['hour'] = messages && messages.hoursBeforeIsRequired;
          }

        });
      }

    }

    setErrors(errorArr);
    return formIsValid;
  }

  const handleSaveLeague = () => {
    setFormSubmitted(true);
    if (handleValidation()) {
      let data = {
        enable_sms_reminder: payload.enable_sms_reminder,
        enable_regular_reminder: payload.enable_sms_reminder && payload.enable_regular_reminder,
        enable_playoff_reminder: payload.enable_sms_reminder && payload.enable_playoff_reminder,

        regular_reminder_user_type: payload.enable_sms_reminder && payload.enable_regular_reminder ? payload.regular_reminder_user_type : null,
        regular_reminder_template: payload.enable_sms_reminder && payload.enable_regular_reminder ? payload.regular_reminder_template : null,
        regular_reschedule_message_template: payload.enable_sms_reminder && payload.enable_regular_reminder ? payload.regular_reschedule_message_template : null,
        regular_cancel_message_template: payload.enable_sms_reminder && payload.enable_regular_reminder ? payload.regular_cancel_message_template : null,
        regular_reminder_settings: payload.enable_sms_reminder && payload.enable_regular_reminder && payload.regular_reminder_settings?.length ? JSON.stringify(payload.regular_reminder_settings) : '',
        regular_reminder_timing: payload.enable_sms_reminder && payload.enable_regular_reminder ? payload.regular_reminder_timing : null,

        playoff_reminder_timing: payload.enable_sms_reminder && payload.enable_playoff_reminder ? payload.playoff_reminder_timing : null,
        playoff_reminder_user_type: payload.enable_sms_reminder && payload.enable_playoff_reminder ? payload.playoff_reminder_user_type : null,
        playoff_reminder_template: payload.enable_sms_reminder && payload.enable_playoff_reminder ? payload.playoff_reminder_template : null,
        playoff_reschedule_message_template: payload.enable_sms_reminder && payload.enable_playoff_reminder ? payload.playoff_reschedule_message_template : null,
        playoff_cancel_message_template: payload.enable_sms_reminder && payload.enable_playoff_reminder ? payload.playoff_cancel_message_template : null,
        playoff_reminder_settings: payload.enable_sms_reminder && payload.enable_playoff_reminder && payload.playoff_reminder_settings?.length ? JSON.stringify(payload.playoff_reminder_settings) : '',

      }

      if (leagueId) {
        axiosApi.put(`${config.apiUrl}/leagues/sms-settings/${Number(leagueId)}`, data).then(() => {
          setFormSubmitted(false);
          getLeague(leagueId);
          history.push({
            pathname: `/admin/leagues/teams/league-settings`,
            search: props && props.location && props.location.state && props.location.state.league_id ? `?leagueId=${props.location.state.league_id}${season_id ? `&season_id=${season_id}` : ''}` : season_id ? `?season_id=${season_id}` : '',
            state: {
              season_id: props && props.location && props.location.state && props.location.state.season_id ? props.location.state.season_id : (season_id ? season_id : 0),
              season_name: props && props.location && props.location.state && props.location.state.season_name ? props.location.state.season_name : '',
              league_id: props.location.state && props.location.state.league_id ? props.location.state.league_id : 0,
            }
          })
        }).catch((err) => {
          console.error(err);
          setFormSubmitted(false);
        });
      }
    }
  }

  const onChange = (resp) => {
    if (resp) {
      setPayload(prevData => ({
        ...prevData,
        [resp.type]: resp.data,
      }));
      let prefix = '';
      if (resp?.type === "enable_playoff_reminder" && resp.data) {
        prefix = 'playoff';
      } else if(resp?.type === "enable_regular_reminder" && resp.data) {
        prefix = 'regular';
      }

      if (prefix) {
        console.log('defaultTemplate', defaultTemplate);
        setPayload(prevData => ({
          ...prevData,
          [`${prefix}_reminder_template`]: defaultTemplate[`${prefix}_reminder_template`] && defaultTemplate[`${prefix}_reminder_template`].body ? defaultTemplate[`${prefix}_reminder_template`].body : '',
          [`${prefix}_reminder_settings`]: defaultTemplate[`${prefix}_reminder_template`] && defaultTemplate[`${prefix}_reminder_template`].settings ? JSON.parse(defaultTemplate[`${prefix}_reminder_template`].settings) : [{}],
          [`${prefix}_reminder_user_type`] : defaultTemplate[`${prefix}_reminder_template`] && defaultTemplate[`${prefix}_reminder_template`][`reminder_user_type`] ? defaultTemplate[`${prefix}_reminder_template`][`reminder_user_type`] : 'all',
          [`${prefix}_reschedule_message_template`]: defaultTemplate[`${prefix}_reschedule_message_template`].body || '',
          [`${prefix}_cancel_message_template`]: defaultTemplate[`${prefix}_cancel_message_template`].body || ''
        }));
      }
    }
  }

  const addReminder = (settingType) => {
    setPayload((prev) => ({ ...prev, [settingType]: [...prev[settingType], {}] }))
  }

  const removeReminder = (settingType, key) => {
    setPayload((prev) => {
      if (prev[settingType][key]) {
        prev[settingType].splice(key, 1);
      }
      return { ...prev, [settingType]: prev[settingType] }
    });
  }


  const onSelectDayBefore = (event, keyName) => {
    setPayload(prevPayload => {
      if (prevPayload[keyName][event.key]) {
        prevPayload[keyName][event.key][event.field] = event.data;
        if (event.field === 'day') {
          prevPayload[keyName][event.key]['schedule_type'] = event.data === 0 ? 'variable' : 'fixed';
        } else if (event.field === 'schedule_type') {
          const field = event.data === 'variable' ? 'time' : 'hour';
          delete prevPayload[keyName][event.key][field];
        }
      }
      return { ...prevPayload, [keyName]: prevPayload[keyName] }
    });
  }
  const addTags = (x, keyName) => {
    const textarea = document.getElementById(keyName);
    const startPos = textarea.selectionStart;
    const endPos = textarea.selectionEnd;

    const updatedContent =
      payload[keyName].substring(0, startPos) +
      x.tag +
      payload[keyName].substring(endPos);

    setPayload((prev) => ({
      ...prev,
      [keyName]: updatedContent,
    }));
    const newPosition = startPos + x.tag.length;
    setTimeout(() => {
      textarea.setSelectionRange(newPosition, newPosition);
      textarea.focus();
    }, 0);
    textarea.focus();
  };

  const getReminderSettings = () => {
    return (
      <div className='twilio-setting-wrapper'>
        <div className='twilio-setting-blk'>
          <div className="enable-regular regular">
            <div className='sub-setting-label'> Regular Matches </div>
            <div className="ls-custom-check-wrapper">
              <label>Enable Reminder</label>
              <div className="ls-custom-check">
                <input type="checkbox" disabled={disabled} checked={payload.enable_regular_reminder} onChange={(e) => onChange({ type: 'enable_regular_reminder', data: !payload.enable_regular_reminder })} />
                <span></span>
              </div>
            </div>
          </div>
          {payload.enable_regular_reminder && <div className='input-section'>
            <div className="input-wrapper send-to">
              <CustomSelect
                disabled={disabled}
                required={true}
                uniqueKey={'send-to'}
                data={[
                  {
                    id: 'all',
                    title: 'All Players'
                  },
                  {
                    id: 'captain',
                    title: 'Captains'
                  },
                ]}
                label={'Send To'}
                placeholder={payload.regular_reminder_user_type ? PLAYER_TYPE[payload.regular_reminder_user_type] : 'Select Player Type'}
                type={'hosted_by'}
                onSelect={(e) => onChange({ type: 'regular_reminder_user_type', data: e?.id || payload.regular_reminder_user_type })}
                selector="title"
              />
              <span className="error p-abs">{formSubmitted && errors?.regular_reminder_user_type}</span>
            </div>
            <div className='multi-blk'>
              {
                payload?.regular_reminder_settings?.length && payload.regular_reminder_settings?.map((val, key) => (
                  <div className='input-group' key={key}>
                    <div className="input-wrapper">
                      <CustomSelect
                        disabled={disabled}
                        required={true}
                        uniqueKey={'regular-day-section'}
                        data={daysData}
                        label={'Day'}
                        placeholder={val.day !== undefined ? daysData[val.day]?.title : 'Select Day'}
                        type={'hosted_by'}
                        onSelect={(e) => {
                          e && onSelectDayBefore({ field: 'day', data: e?.value, key }, 'regular_reminder_settings');
                        }}
                        selector="title"
                      />
                      <span className="error">{formSubmitted && errors?.regular_reminder_settings?.[key]?.["day"]}</span>
                    </div>
                    {
                      val.day === 0 && <div className="input-field">
                        <CustomSelect
                          disabled={disabled}
                          required={true}
                          uniqueKey={'regular-schedule-type'}
                          data={[
                            {
                              title: "Fixed Time", value: "fixed"
                            },
                            {
                              title: "Relative hour(s)", value: "variable"
                            }
                          ]}
                          label={'Schedule Type'}
                          placeholder={val.schedule_type !== undefined ? SCHEDULE_TYPE[val.schedule_type] : 'Select Schedule Type'}
                          type={'hosted_by'}
                          onSelect={(e) => e && onSelectDayBefore({ field: 'schedule_type', data: e?.value || val?.schedule_type, key }, 'regular_reminder_settings')}
                          selector="title"
                        />
                        <span className="error">{formSubmitted && errors?.regular_reminder_settings?.[key]?.["schedule_type"]}</span>
                      </div>
                    }

                    {
                      val.day === 0 && val.schedule_type === 'variable' && <div className="input-field">
                        <CustomSelect
                          disabled={disabled}
                          required={true}
                          uniqueKey={'regular-hour-selection'}
                          data={hoursData}
                          label={'Hour'}
                          placeholder={val.hour !== undefined ? hoursData[val.hour - 1]?.title : 'Select Hour'}
                          type={'hosted_by'}
                          onSelect={(e) => e && onSelectDayBefore({ field: 'hour', data: e?.value, key }, 'regular_reminder_settings')}
                          selector="title"
                        />
                        <span className="error">{formSubmitted && errors?.regular_reminder_settings?.[key]?.["hour"]}</span>
                      </div>
                    }
                    {
                      ((val.day === 0 && val.schedule_type === 'fixed') || val.day !== 0) &&
                      <div className="input-field">
                        <Timepicker
                          isDisabled={disabled}
                          required={true}
                          time={val.time}
                          callback={(e) => e && onSelectDayBefore({ field: 'time', data: e, key }, 'regular_reminder_settings')}
                        />
                        <span className="error">{formSubmitted && errors?.regular_reminder_settings?.[key]?.["time"]}</span>
                      </div>
                    }

                    <div className='action-btn'>
                      {payload?.regular_reminder_settings?.length - 1 === key && <button onClick={() => addReminder('regular_reminder_settings')}><img src={plusSvg} alt="add" /></button>}
                      {payload?.regular_reminder_settings?.length > 1 && <button onClick={() => removeReminder('regular_reminder_settings', key)}><img src={minusSvg} alt="remove" /></button>}
                    </div>
                  </div>
                ))
              }
            </div>
            <div className="input-wrapper">
              <div className="message-box">
                <label>Message Template<sup>*</sup>:</label>
                <textarea id="regular_reminder_template" disabled={disabled} onChange={(e) => onChange({ type: 'regular_reminder_template', data: e.target.value })} value={payload.regular_reminder_template} width="400" height="250" />
                <div className="tags">
                  {
                    TAGS.filter(x => !OLD_TAGS.includes(x.label)).map((x, key) => (
                      <span key={key} onClick={() => { !disabled && addTags(x, 'regular_reminder_template') }}>{x.label}</span>
                    ))
                  }
                </div>

                <span className="error">{formSubmitted && errors?.regular_reminder_template}</span>
              </div>
            </div>

            <div className="input-wrapper">
              <div className="message-box">
                <label>Reschedule Message Template<sup>*</sup>:</label>
                <textarea id="regular_reschedule_message_template" disabled={disabled} onChange={(e) => onChange({ type: 'regular_reschedule_message_template', data: e.target.value })} value={payload.regular_reschedule_message_template} width="400" height="250" />
                <div className="tags">
                  {
                    TAGS.map((x) => (
                      <span onClick={() => { !disabled && addTags(x, 'regular_reschedule_message_template') }}>{x.label}</span>
                    ))
                  }
                </div>
                <span className="error">{formSubmitted && errors?.regular_reschedule_message_template}</span>
              </div>
            </div>

            <div className="input-wrapper">
              <div className="message-box">
                <label>Cancel Message Template<sup>*</sup>:</label>
                <textarea id="regular_cancel_message_template" disabled={disabled} onChange={(e) => onChange({ type: 'regular_cancel_message_template', data: e.target.value })} value={payload.regular_cancel_message_template} width="400" height="250" />
                <div className="tags">
                  {
                    TAGS.filter(x => !OLD_TAGS.includes(x.label)).map((x) => (
                      <span onClick={() => { !disabled && addTags(x, 'regular_cancel_message_template') }}>{x.label}</span>
                    ))
                  }
                </div>
                <span className="error">{formSubmitted && errors?.regular_cancel_message_template}</span>
              </div>
            </div>
          </div>}
        </div>

        <div className='twilio-setting-blk'>
          <div className="enable-regular">
            <div className='sub-setting-label'> Playoff Matches </div>
            <div className="ls-custom-check-wrapper">
              <label>Enable Reminder</label>
              <div className="ls-custom-check">
                <input type="checkbox" disabled={disabled} checked={payload.enable_playoff_reminder} onChange={(e) => onChange({ type: 'enable_playoff_reminder', data: !payload.enable_playoff_reminder })} />
                <span></span>
              </div>
            </div>

          </div>
          {payload.enable_playoff_reminder && <div className='input-section'>

            <div className="input-wrapper">
              <CustomSelect
                disabled={disabled}
                required={true}
                uniqueKey={'send-to'}
                data={[
                  {
                    id: 'all',
                    title: 'All Players'
                  },
                  {
                    id: 'captain',
                    title: 'Captains'
                  },
                ]}
                label={'Send To'}
                placeholder={payload.playoff_reminder_user_type ? PLAYER_TYPE[payload.playoff_reminder_user_type] : 'Select Player Type'}
                type={'hosted_by'}
                onSelect={(e) => onChange({ type: 'playoff_reminder_user_type', data: e?.id || payload.playoff_reminder_user_type })}
                selector="title"
              />
              <span className="error p-abs">{formSubmitted && errors?.playoff_reminder_user_type}</span>
            </div>
            <div className='multi-blk'>
              {
                payload?.playoff_reminder_settings?.length && payload.playoff_reminder_settings?.map((val, key) => (
                  <div className='input-group' key={key}>
                    <div className="input-wrapper">
                      <CustomSelect
                        disabled={disabled}
                        required={true}
                        uniqueKey={'playoff-day-section'}
                        data={daysData}
                        label={'Day'}
                        placeholder={val.day !== undefined ? daysData[val.day]?.title : 'Select Day'}
                        type={'hosted_by'}
                        onSelect={(e) => {
                          e && onSelectDayBefore({ field: 'day', data: e?.value, key }, 'playoff_reminder_settings');
                        }}
                        selector="title"
                      />
                      <span className="error">{formSubmitted && errors?.playoff_reminder_settings?.[key]?.["day"]}</span>
                    </div>
                    {
                      val.day === 0 && <div className="input-field">
                        <CustomSelect
                          disabled={disabled}
                          required={true}
                          uniqueKey={'playoff-schedule-type'}
                          data={[
                            {
                              title: "Fixed Time", value: "fixed"
                            },
                            {
                              title: "Relative hour(s)", value: "variable"
                            }
                          ]}
                          label={'Schedule Type'}
                          placeholder={val.schedule_type !== undefined ? SCHEDULE_TYPE[val.schedule_type] : 'Select Schedule Type'}
                          type={'hosted_by'}
                          onSelect={(e) => e && onSelectDayBefore({ field: 'schedule_type', data: e?.value || val?.schedule_type, key }, 'playoff_reminder_settings')}
                          selector="title"
                        />
                        <span className="error">{formSubmitted && errors?.playoff_reminder_settings?.[key]?.["schedule_type"]}</span>
                      </div>
                    }

                    {
                      val.day === 0 && val.schedule_type === 'variable' && <div className="input-field">
                        <CustomSelect
                          disabled={disabled}
                          required={true}
                          uniqueKey={'playoff-hour-selection'}
                          data={hoursData}
                          label={'Hour'}
                          placeholder={val.hour !== undefined ? hoursData[val.hour - 1]?.title : 'Select Hour'}
                          type={'hosted_by'}
                          onSelect={(e) => e && onSelectDayBefore({ field: 'hour', data: e?.value, key }, 'playoff_reminder_settings')}
                          selector="title"
                        />
                        <span className="error">{formSubmitted && errors?.playoff_reminder_settings?.[key]?.["hour"]}</span>
                      </div>
                    }
                    {
                      ((val.day === 0 && val.schedule_type === 'fixed') || val.day !== 0) &&
                      <div className="input-field">
                        <Timepicker
                          isDisabled={disabled}
                          required={true}
                          time={val.time}
                          callback={(e) => e && onSelectDayBefore({ field: 'time', data: e, key }, 'playoff_reminder_settings')}
                        />
                        <span className="error">{formSubmitted && errors?.playoff_reminder_settings?.[key]?.["time"]}</span>
                      </div>
                    }

                    <div className='action-btn'>
                      {payload?.playoff_reminder_settings?.length - 1 === key && <button onClick={() => addReminder('playoff_reminder_settings')}><img src={plusSvg} alt="add" /></button>}
                      {payload?.playoff_reminder_settings?.length > 1 && <button onClick={() => removeReminder('playoff_reminder_settings', key)}><img src={minusSvg} alt="remove" /></button>}
                    </div>
                  </div>
                ))
              }
            </div>
            <div className="input-wrapper">
              <div className="message-box">
                <label>Message Template<sup>*</sup>:</label>
                <textarea id="playoff_reminder_template" disabled={disabled} onChange={(e) => onChange({ type: 'playoff_reminder_template', data: e.target.value })} value={payload.playoff_reminder_template} width="400" height="250" />
                <div className="tags">
                  {
                    TAGS.filter(x => !OLD_TAGS.includes(x.label)).map((x) => (
                      <span onClick={() => { !disabled && addTags(x, 'playoff_reminder_template') }}>{x.label}</span>
                    ))
                  }
                </div>
                <span className="error">{formSubmitted && errors?.playoff_reminder_template}</span>
              </div>
            </div>

            <div className="input-wrapper">
              <div className="message-box">
                <label>Reschedule Message Template<sup>*</sup>:</label>
                <textarea id="playoff_reschedule_message_template" disabled={disabled} onChange={(e) => onChange({ type: 'playoff_reschedule_message_template', data: e.target.value })} value={payload.playoff_reschedule_message_template} width="400" height="250" />
                <div className="tags">
                  {
                    TAGS.map((x) => (
                      <span onClick={() => { !disabled && addTags(x, 'playoff_reschedule_message_template') }}>{x.label}</span>
                    ))
                  }
                </div>
                <span className="error">{formSubmitted && errors?.playoff_reschedule_message_template}</span>
              </div>
            </div>

            <div className="input-wrapper">
              <div className="message-box">
                <label>Cancel Message Template<sup>*</sup>:</label>
                <textarea id="playoff_cancel_message_template" disabled={disabled} onChange={(e) => onChange({ type: 'playoff_cancel_message_template', data: e.target.value })} value={payload.playoff_cancel_message_template} width="400" height="250" />
                <div className="tags">
                  {
                    TAGS.filter(x => !OLD_TAGS.includes(x.label)).map((x) => (
                      <span onClick={() => { !disabled && addTags(x, 'playoff_cancel_message_template') }}>{x.label}</span>
                    ))
                  }
                </div>
                <span className="error">{formSubmitted && errors?.playoff_cancel_message_template}</span>
              </div>
            </div>
          </div>}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={disabled ? "addLeague-wrapper faded" : "addLeague-wrapper"}>
        <div className="top-blk ls-top-blk">
          <Link to={{
            pathname: `/admin/leagues/teams/league-settings`,
            search: props && props.location && props.location.state && props.location.state.league_id ? `?leagueId=${props.location.state.league_id}${season_id ? `&season_id=${season_id}` : ''}` : season_id ? `?season_id=${season_id}` : '',
            state: {
              season_id: props && props.location && props.location.state && props.location.state.season_id ? props.location.state.season_id : (season_id ? season_id : 0),
              season_name: props && props.location && props.location.state && props.location.state.season_name ? props.location.state.season_name : '',
              league_id: props.location.state && props.location.state.league_id ? props.location.state.league_id : 0,
            }
          }}><button className="back-btn"><img src={back} alt='back-icon' />Back to League Settings</button></Link>
          <div className="heading-blk">
            <h2 className="heading">SMS Settings</h2>
          </div>
          <div className='setting-section'>
            <div className="input-blk">
              <div className="ls-custom-check-wrapper">
                <label>Enable SMS Setting</label>
                <div className="ls-custom-check">

                  <input type="checkbox" disabled={disabled} checked={payload.enable_sms_reminder} onChange={(e) => onChange({ type: 'enable_sms_reminder', data: !payload.enable_sms_reminder })} />
                  <span></span>
                </div>
              </div>
              <div className="reminder-setting">
                {!!payload?.enable_sms_reminder && getReminderSettings()}
              </div>
            </div>
          </div>
        </div>
        <div className="footer-blk">
          <button disabled={disabled} onClick={handleSaveLeague}>Save Changes</button>
        </div>
      </div>
    </>
  );
}

export default withRouter(SmsSettings);
